"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useModeColor;
var React = _interopRequireWildcard(require("react"));
var _useEvent = _interopRequireDefault(require("rc-util/lib/hooks/useEvent"));
var _useMergedState = _interopRequireDefault(require("rc-util/lib/hooks/useMergedState"));
var _locale = require("../../locale");
var _util = require("../util");
/**
 * Combine the `color` and `mode` to make sure sync of state.
 */
function useModeColor(defaultValue, value, mode) {
  var _ref = (0, _locale.useLocale)('ColorPicker'),
    _ref2 = _slicedToArray(_ref, 1),
    locale = _ref2[0];
  // ======================== Base ========================
  // Color
  var _ref3 = (0, _useMergedState["default"])(defaultValue, {
      value: value
    }),
    _ref4 = _slicedToArray(_ref3, 2),
    mergedColor = _ref4[0],
    setMergedColor = _ref4[1];
  // Mode
  var _React$useState = React.useState('single'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    modeState = _React$useState2[0],
    setModeState = _React$useState2[1];
  var _React$useMemo = React.useMemo(function () {
      var list = (Array.isArray(mode) ? mode : [mode]).filter(function (m) {
        return m;
      });
      if (!list.length) {
        list.push('single');
      }
      var modes = new Set(list);
      var optionList = [];
      var pushOption = function pushOption(modeType, localeTxt) {
        if (modes.has(modeType)) {
          optionList.push({
            label: localeTxt,
            value: modeType
          });
        }
      };
      pushOption('single', locale.singleColor);
      pushOption('gradient', locale.gradientColor);
      return [optionList, modes];
    }, [mode]),
    _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
    modeOptionList = _React$useMemo2[0],
    modeSet = _React$useMemo2[1];
  // ======================== Post ========================
  // We need align `mode` with `color` state
  // >>>>> Color
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    cacheColor = _React$useState4[0],
    setCacheColor = _React$useState4[1];
  var setColor = (0, _useEvent["default"])(function (nextColor) {
    setCacheColor(nextColor);
    setMergedColor(nextColor);
  });
  var postColor = React.useMemo(function () {
    var colorObj = (0, _util.generateColor)(mergedColor || '');
    // Use `cacheColor` in case the color is `cleared`
    return colorObj.equals(cacheColor) ? cacheColor : colorObj;
  }, [mergedColor, cacheColor]);
  // >>>>> Mode
  var postMode = React.useMemo(function () {
    var _a;
    if (modeSet.has(modeState)) {
      return modeState;
    }
    return (_a = modeOptionList[0]) === null || _a === void 0 ? void 0 : _a.value;
  }, [modeSet, modeState, modeOptionList]);
  // ======================= Effect =======================
  // Dynamic update mode when color change
  React.useEffect(function () {
    setModeState(postColor.isGradient() ? 'gradient' : 'single');
  }, [postColor]);
  // ======================= Return =======================
  return [postColor, setColor, postMode, setModeState, modeOptionList];
}